import {NewSurveyor} from "../NewSurveyor";
import styles from "./pagina_surveyor.module.css";
import img from "./logo_surveyor.png"
import React, {useContext} from "react";
import LangContext from "../../../../context/LangContext";
import spain from "../../../header/spain.png";
import england from "../../../header/united-kingdom.png";

export const IngresarSurveyorPorPagina = () => {
const {traduccion,handleLanguage} = useContext(LangContext);
    return (
        <>
            <div className={styles.contenedor}>
                <div className={styles.lang}>
                    {(localStorage.getItem("lang")==='es')? <img src={spain} alt="es" style={{marginRight:5, marginBottom:4}} /> : <img src={england} alt="en" style={{marginRight:5, marginBottom:4}} />  }
                    <select defaultValue={localStorage.getItem("lang")} name="language" onChange={handleLanguage}>
                        <option value="es">ES</option>
                        <option value="en">EN</option>
                    </select>
                </div>
                <div className={styles.contenedor_img}>
                    <img src={img} alt="surveyor"/>
                </div>

                <NewSurveyor paginaSurveyors={true}/>
            </div>
        </>
    )
}